export default "__VITE_ASSET__CA2j6L_x__"